import { render } from "./App.vue?vue&type=template&id=64ed008b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=64ed008b&lang=less"

import exportComponent from "/Users/yhy/works/project/nutrition/nutrition-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__